/**
 * CloudWatch RUM requires userId to match UUID format.
 * Auth0 subs (e.g. google-oauth2|116598...) are not valid — map to a stable UUID v4-shaped id.
 */
export const auth0SubToRumUserId = async (auth0Sub: string): Promise<string> => {
  const data = new TextEncoder().encode(`lingk-rum-user:${auth0Sub}`);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hash = new Uint8Array(hashBuffer);

  // RFC 4122: version 4 + variant bits on a deterministic hash
  hash[6] = (hash[6] & 0x0f) | 0x40;
  hash[8] = (hash[8] & 0x3f) | 0x80;

  const hex = Array.from(hash.slice(0, 16), (byte) => byte.toString(16).padStart(2, '0')).join('');

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
};
